export default __webpack_public_path__ + "static/media/insights-yellow-filled.fdeb0415.svg";